import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import {
  DownloadButton,
  InputSelectStyle, ReportStyles, StyledTable,
  TableWrapper,
} from './Report.styles';
import InputSelect from '../../common/components/inputs/InputSelect';
import { lastSixYears } from '../../common/constants';
import { getReport } from '../../features/reports/reportsActions';
import PageLoading from '../../common/components/elements/PageLoading';
import managementAxe from '../../services/axios-client/managementServisAxeClient';
import { generalAlertError } from '../../common/utils/alerts';
import { downloadFile } from '../../services/axios-client/axeHelpers';

function Report() {
  const { loading, reports } = useSelector((store) => store.report);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  const currentYear = selectedYear;
  const prevYear = selectedYear - 1;

  const downloadExcel = async (month, year) => {
    const res = await managementAxe.get('/broker/download/export-report', {
      params: {
        month,
        year,
      },
      responseType: 'blob',
    });

    if (res.status !== 200) {
      generalAlertError('Nessun Preventivo Trovato!');
      return;
    }

    downloadFile(res.data);
  };

  useEffect(() => {
    getReport(selectedYear);
  }, [selectedYear]);

  if (loading) {
    return <PageLoading />;
  }

  const categories = reports?.monthly_amounts.map((item) => item.month);

  const series = [
    {
      name: `Numero di Polizze ${currentYear}`,
      data: reports?.monthly_amounts.map((item) => item.quotation_month_count ?? 0),
    },
    {
      name: `Numero di Polizze ${prevYear}`,
      data: reports?.monthly_amounts.map((item) => item.quotation_month_count_prev_year ?? 0),
    },
  ];

  const options = {
    chart: {
      type: 'bar',
      height: 350,
      toolbar: { show: false },
      stacked: false,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '50%',
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: '12px',
        colors: ['#000'],
      },
    },
    xaxis: {
      categories,
    },
    yaxis: {
      title: {
        text: 'Numero di Polizze',
      },
    },
    legend: {
      position: 'bottom',
      fontSize: '13px',
      itemMargin: {
        horizontal: 20, // ✅ increase space between items
        vertical: 8,
      },
    },
    colors: ['#00a651', '#CED4DC'], // Blue for current year, gray for last year
  };

  return (
    <ReportStyles>

      <div className="d-flex justify-content-between">
        <h2 className="fs-3">Report</h2>

      </div>

      <InputSelectStyle className="select-broker">
        <InputSelect
          label="Seleziona Anno"
          placeholder="- Seleziona -"
          options={lastSixYears}
          colClass="m-0 w-100"
          value={selectedYear}
          onChange={(val) => {
            setSelectedYear(val);
          }}

        />
      </InputSelectStyle>

      <div className="row mb-4 select-result-intervallo gap-3">
        <div className="col-12 col-md-3 col-xl-2 mb-3 mb-xl-0 p-0">
          <div className="custom-card">
            <div className="custom-card-header">
              <b>Totale</b>
            </div>
            <div className="custom-card-body">
              <div className="card-data">
                <p>Premi netti</p>
                <h5>
                  &euro;
                  {' '}
                  {reports?.total_amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </h5>
                <p className="mt-2">
                  Polizze:
                  {' '}
                  <span>
                    {reports?.quotation_count}
                  </span>
                </p>

              </div>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-3  col-xl-2 mb-3 mb-xl-0 p-0">
          <div className="custom-card">
            <div className="custom-card-header">
              <b>Motor</b>
            </div>
            <div className="custom-card-body">
              <div className="card-data">
                <p>Premi netti</p>
                <h5>
                  &euro;
                  {' '}
                  {reports?.vehicles_quote_amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </h5>
                <p className="mt-2">
                  Polizze:
                  {' '}
                  <span>
                    {' '}
                    {reports?.vehicle_quote_count}
                  </span>
                </p>

              </div>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-3  col-xl-2 mb-3 mb-xl-0 p-0">
          <div className="custom-card">
            <div className="custom-card-header">
              <b>Altri</b>
            </div>
            <div className="custom-card-body">
              <div className="card-data">
                <p>Premi netti</p>
                <h5>
                  &euro;
                  {' '}
                  {reports?.other_quote_amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </h5>
                <p className="mt-2">
                  Polizze:
                  {' '}
                  <span>{reports?.other_quote_count}</span>
                </p>

              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-3  col-xl-2 mb-3 mb-xl-0 p-0">
          <div className="custom-card h-100">
            <div className="custom-card-header">
              <b>Commisioni</b>
            </div>
            <div className="custom-card-body">
              <div className="card-data">
                <p>Totale</p>
                <h5>
                  &euro;
                  {' '}
                  {reports?.commision.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </h5>

              </div>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-3  col-xl-2 mb-3 mb-xl-0 p-0">
          <div className="custom-card h-100">
            <div className="custom-card-header">
              <b>Brokeraggio</b>
            </div>
            <div className="custom-card-body">
              <div className="card-data">
                <p>Totale</p>

                <h5>
                  &euro;
                  {' '}
                  {reports?.brokerage_amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </h5>

              </div>
            </div>
          </div>
        </div>

      </div>
      {/* <div className="row mt-3">
        <div className="col-12 col-md-6 col-xl-2 mb-3 mb-xl-0">
          <div className="custom-card">
            <div className="custom-card-header">
              <b>Commisioni</b>
            </div>
            <div className="custom-card-body">
              <div className="card-data">

                <h5>
                  &euro;
                  {' '}
                  {reports?.commision.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </h5>

              </div>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6 col-xl-2 mb-3 mb-xl-0">
          <div className="custom-card">
            <div className="custom-card-header">
              <b>Brokeraggio</b>
            </div>
            <div className="custom-card-body">
              <div className="card-data">

                <h5>
                  &euro;
                  {' '}
                  {reports?.brokerage_amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </h5>

              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div className="row">
        <div className="col-12 mb-3 mb-md-0 chart-one-broker-report">
          <div className="mt-2">
            {/* <h4 className="text-center fw-bold mb-0">
              Analisi Bisogni Cliente
            </h4> */}
            <Chart
              options={options}
              series={series}
              height="350px"
              type="bar"
            />
          </div>
        </div>

      </div>

      <TableWrapper className="mt-3">
        <StyledTable>
          <thead>
            <tr>
              <th>MESE</th>
              <th>POLIZZE</th>
              <th>PREMI NETTI TOTALI</th>
              <th>COMMISSIONI</th>
              <th>BROKERAGGIO</th>
              <th>REPORT</th>
            </tr>
          </thead>
          <tbody>
            {reports?.monthly_amounts.map((row, i) => (
              <tr key={i}>
                <td>{row.month}</td>
                <td>{row.quotation_month_count}</td>
                <td>
                  &euro;
                  {' '}
                  {row.amount_paid.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </td>
                <td>
                  &euro;
                  {' '}
                  {row.monthly_commision.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </td>
                <td>
                  &euro;
                  {' '}
                  {row.monthly_brokerage_amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  { }
                </td>
                <td>
                  <DownloadButton onClick={() => downloadExcel(row.month_number, selectedYear)}>
                    <FontAwesomeIcon icon={faDownload} />
                    Scarica
                  </DownloadButton>

                </td>
              </tr>
            ))}
          </tbody>
        </StyledTable>
      </TableWrapper>

    </ReportStyles>
  );
}

export default Report;
